import React from "react";
import { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { TemplateOfferingCheckoutTranzilaDayPass } from "../template_offering_checkout_tranzila_daypass";
import { useWeWorkAnalytics } from "./wework_analytics";
import { useWeWorkPartnerConfig } from "./wework_partner_config";

const Theme = lazyWithRetry(() => import("./wework_theme"));

export function OfferingWeWorkCheckoutDayPass() {
  const partnerConfig = useWeWorkPartnerConfig();
  useWeWorkAnalytics();
  return (
    <Fragment>
      <Theme />
      <TemplateOfferingCheckoutTranzilaDayPass
        includeQuantity={false}
        firstDayOfWeek={0}
        partnerConfig={partnerConfig}
      />
    </Fragment>
  );
}
